var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchedulesDropdownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 4.5L8 11.1667L3 4.5L13 4.5Z",
    fill: "#303141",
    stroke: "#303141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedulesDropdownIcon);
export default __webpack_public_path__ + "static/media/schedules-dropdown-icon.4a422dd7960db2cb2b8a17eba30405bd.svg";
export { ForwardRef as ReactComponent };